import Container from '@mui/material/Container';
import React from 'react';
import SqPaper from './SqPaper';

export default function PagePaper(props: any) {
  return (
    <>
      <Container
        style={{
          display: 'flex',
          flexDirection: 'row',

          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <SqPaper elevation={1} sx={{ width: '100%' }}>
          {props.children}
        </SqPaper>
      </Container>
    </>
  );
}
